export default [
    {
        name: 'twaAll',
        path: 'twaAll',
        component: () => import('@/pages/BigData/TrademarkModule/TMDocWritTrans/twaAll'),
        meta: { title: '全部' },
        props(route) {
            return { id: route.query.id }
        }
    },
    {
        name: 'tToBeWritten',
        path: 'tToBeWritten',
        component: () => import('@/pages/BigData/TrademarkModule/TMDocWritTrans/tToBeWritten'),
        meta: { title: '待撰写' },
        props(route) {
            return { id: route.query.id }
        }
    },
    {
        name: 'twaWriting',
        path: 'twaWriting',
        component: () => import('@/pages/BigData/TrademarkModule/TMDocWritTrans/twaWriting'),
        meta: { title: '撰写中' },
        props(route) {
            return { id: route.query.id }
        }
    },
    {
        name: 'twaConfirming',
        path: 'twaConfirming',
        component: () => import('@/pages/BigData/TrademarkModule/TMDocWritTrans/twaConfirming'),
        meta: { title: '确认中' },
        props(route) {
            return { id: route.query.id }
        }
    },
    {
        name: 'twaConfirmed',
        path: 'twaConfirmed',
        component: () => import('@/pages/BigData/TrademarkModule/TMDocWritTrans/twaConfirmed'),
        meta: { title: '已确认' },
        props(route) {
            return { id: route.query.id }
        }
    },
    {
        name: 'TCopyRightDetails',
        path: 'TCopyRightDetails',
        redirect: { name: 'TRawMaterials' },
        component: () => import('@/pages/BigData/TrademarkModule/TCopyRightDetails'),
        meta: { title: '详情' },
        props(route) {
            return { id: route.query.id }
        },
        children: [
            {
                name: 'TRawMaterials',
                path: 'TRawMaterials',
                component: () => import('@/pages/BigData/TrademarkModule/TCopyRightDetails/TRawMaterials'),
                meta: { title: '原始材料' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            },
            {
                name: 'TConfirmMaterial',
                path: 'TConfirmMaterial',
                component: () => import('@/pages/BigData/TrademarkModule/TCopyRightDetails/TConfirmMaterial'),
                meta: { title: '需确认材料' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            }

        ]
    },
]